import { exportBudgetDetailList, getBudgetDetailList } from '../services';

export default {
  namespace: 'detailedBudget',
  state: {},
  effects: {
    // 预算明细查询列表
    *getBudgetDetailList({ payload }, { call }) {
      return yield call(getBudgetDetailList, payload);
    },

    // // 预算明细导出列表
    *exportBudgetDetailList({ payload }, { call }) {
      return yield call(exportBudgetDetailList, payload);
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
